'use strict';
export default {
	'VALIDATIONS':{
		'EMAIL':/^[A-Z0-9_]([A-Z0-9._-]|\+)*@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
		'ALPHA_NUM_DOT':/^[a-zA-Z0-9.]*$/,
		'ALPHA_NUM_DOT_DASH':/^[a-zA-Z0-9.-]*$/,
		'NUMERIC_ONLY':/^[0-9]*$/,
		'URL':/^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,})$/,
		'PERCENTAGE':/^(?:100|[1-9]?[0-9])$/
	}
};


// WEBPACK FOOTER //
// ./src/app/common/constants.js